import { Injectable } from '@angular/core';
import { AuthService } from 'services';
import { ApiClientService } from './common/api-client.service';
import { Observable } from 'rxjs';
import { Activity } from '../models/activity.model';
import { ActivityLogFilter } from '../models/activity-log-filter.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(private apiClient: ApiClientService) { }

  public getActivity(requestType: number, requestTypeId: number): Observable<any> {
    return this.apiClient.get('api/Activity/' + requestType + '/' + requestTypeId, undefined, undefined, false);
  }

  public logActivity(activity: Activity): Observable<number> {
    return this.apiClient.post('api/Activity', activity, null, false);
  }

  public getActivityLog(activityLogFilter: ActivityLogFilter): Observable<any> {
    return this.apiClient.post('api/activity/getActivityLog', activityLogFilter, undefined, true);
  }

  public getActivityTypes(activityLogFilter: ActivityLogFilter , isloder:boolean=false): Observable<any> {
    return this.apiClient.post(`api/activity/getActivityTypes`, activityLogFilter, undefined, isloder);
  }
}
